import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';
import VideoPlayIcon from '@atlaskit/icon/core/video-play';
import { useShortcutStrings } from '@confluence/shortcuts/entry-points/ShortcutVisualizer.ts';

import { contentPresentationService } from '../services/content-presentation-service.ts';

const PRESENT_SHORTCUT = 'mod+option+r';

const i18n = defineMessages({
	label: {
		id: 'content-types-header.content-types.present-slides-button.label',
		defaultMessage: 'Present',
		description: 'Label for the Present button in the header that starts slide presentation mode',
	},
});

export const PresentSlidesButton = () => {
	const intl = useIntl();
	const [isAvailable, setIsAvailable] = useState(contentPresentationService.isAvailable);
	const shortcutStrings = useShortcutStrings({ shortcut: PRESENT_SHORTCUT });

	useEffect(() => {
		return contentPresentationService.onAvailabilityChange(setIsAvailable);
	}, []);

	if (!isAvailable) {
		return null;
	}

	return (
		<Tooltip content={intl.formatMessage(i18n.label)} shortcut={shortcutStrings}>
			<Button iconBefore={VideoPlayIcon} onClick={() => contentPresentationService.startPresent()}>
				{intl.formatMessage(i18n.label)}
			</Button>
		</Tooltip>
	);
};
